import { Empty } from "antd";
import dayjs from "dayjs";
import { FC, useMemo } from "react";
import { CheckoutOrder } from "tm-shared/types";

import { useAppSelector } from "@/hooks/redux";

import { CheckoutItem } from "../CheckoutItem";
import { StatisticAccordion } from "../StatisticAccordion";
import { StyledCLList } from "./Styled";

const sortByDateDesc = (list: Record<string, CheckoutOrder>) =>
    (Object.values(list) as CheckoutOrder[]).sort((a, b) =>
        dayjs(b.creationDate).diff(dayjs(a.creationDate)),
    );

interface CheckoutListProps {
    checkedOrderIds: Set<string>;
    onToggleOrderId: (orderId: string) => void;
    onReset: () => void;
}

export const CheckoutList: FC<CheckoutListProps> = ({
    checkedOrderIds,
    onToggleOrderId,
    onReset,
}) => {
    const { checkoutOpenedList, checkoutClosedList } = useAppSelector(
        (state) => ({
            checkoutOpenedList: state.work.checkoutList,
            checkoutClosedList: state.work.checkoutCompletedList,
        }),
    );

    const openedCheckouts = useMemo(
        () => sortByDateDesc(checkoutOpenedList),
        [checkoutOpenedList],
    );

    const closedCheckouts = useMemo(
        () => sortByDateDesc(checkoutClosedList),
        [checkoutClosedList],
    );

    const checkoutValues = useMemo(
        () => [...openedCheckouts, ...closedCheckouts],
        [openedCheckouts, closedCheckouts],
    );

    return (
        <>
            {checkoutValues.length === 0 ? (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Немає замовлень"
                />
            ) : (
                <>
                    <StatisticAccordion checkouts={checkoutValues} />

                    <StyledCLList>
                        {checkoutValues.map((checkout) => {
                            const { orderId } = checkout;

                            return (
                                <CheckoutItem
                                    key={orderId}
                                    checkoutOrder={checkout}
                                    isChosen={checkedOrderIds.has(orderId)}
                                    onSelect={() => onToggleOrderId(orderId)}
                                    onReset={onReset}
                                />
                            );
                        })}
                    </StyledCLList>
                </>
            )}
        </>
    );
};
